/** @jsx jsx */
import { jsx } from 'theme-ui';
export var DropdownIcon = function (_a) {
    var className = _a.className;
    return (jsx("div", { sx: {
            display: 'inline-block',
            width: '1em',
            height: '1em',
        }, className: className, "aria-label": "menu" },
        jsx("svg", { viewBox: "0 0 100 100", xmlns: "http://www.w3.org/2000/svg", css: {
                width: '100%',
                height: '100%',
            } },
            jsx("line", { x1: 10, y1: 40, x2: 50, y2: 80, css: { stroke: 'currentColor', strokeWidth: 7 } }),
            jsx("line", { x1: 50, y1: 80, x2: 90, y2: 40, css: { stroke: 'currentColor', strokeWidth: 7 } }))));
};
//# sourceMappingURL=DropdownIcon.js.map